"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawOpponent = void 0;
const pixi_js_1 = require("pixi.js");
const DrawCanvas_1 = require("./DrawCanvas");
const Global_1 = require("../Global");
const brushpoint_svg_1 = __importDefault(require("../../assets/svg/brushpoint.svg"));
const colors_1 = require("../config/colors");
const settings_1 = require("../config/settings");
const Opponent_1 = require("./Opponent");
const NameBanner_1 = require("./NameBanner");
const levels_1 = require("../../../shared/levels");
const config_json_1 = __importDefault(require("../../../shared/config.json"));
class DrawOpponent extends Opponent_1.Opponent {
    constructor(app, gameManager, pkey) {
        super(app, pkey);
        this.gameManager = gameManager;
        this.canvas = this.makeCanvas();
        this.header = this.makeHeader(this.canvas);
        this.subs.add(this.gameManager.roomStream.submit$.subscribe({
            next: (item) => {
                var _a;
                if (item.pkey === this.pkey) {
                    if (!item.pt && !item.stroke) {
                        this.canvas.clear();
                    }
                    else {
                        this.canvas.stroke = colors_1.colors[((_a = this.gameManager.opponent(this.pkey)) === null || _a === void 0 ? void 0 : _a.c) || 0] || settings_1.Settings.drawColor;
                        this.canvas.addRelativePoint(item.pt, item.stroke);
                    }
                }
                else {
                    // My update, or another opponents...
                }
            }
        }));
        this.layout();
    }
    makeBrush() {
        const win = pixi_js_1.Sprite.from(brushpoint_svg_1.default);
        win.rotation = Math.PI;
        win.anchor.set(0.5);
        win.scale.set((0, Global_1.px)(0.05));
        win.position.set(this.canvas.width / 2, this.canvas.height / 2);
        return this.canvas.addChild(win);
    }
    inOverlay(color = settings_1.Settings.whiteColor, duration = 0.15) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.canvas.inOverlay(color, duration);
        });
    }
    makeCanvas() {
        const canvas = new DrawCanvas_1.DrawCanvas(this.app, {
            width: 105,
            height: 105,
            disabled: true,
            strokeWidth: this.overSmallSize ? 4 : 3,
            borderWidth: 2,
            // blur: 6
        });
        return this.addChild(canvas);
    }
    get me() {
        return this.gameManager.opponent(this.pkey);
    }
    makeHeader(canvas) {
        var _a;
        const level = ((_a = this.me) === null || _a === void 0 ? void 0 : _a.lvl) ? levels_1.levels[this.me.lvl - 1] : null;
        const box = new NameBanner_1.NameBanner(this.app, this.me, level, canvas.size.width, 54);
        box.color = settings_1.Settings.lightLightGrayColor;
        box.score = this.score;
        return this.addChild(box);
    }
    get score() {
        return Math.min(this.gameManager.score(this.pkey) || 0, config_json_1.default.battlescore);
    }
    layout() {
        this.header.position.set((0, Global_1.px)(this.canvas.size.width / 2), 0);
        this.canvas.y = (0, Global_1.px)(this.header.h / 4);
        super.layout();
    }
}
exports.DrawOpponent = DrawOpponent;
